import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import parse from "html-react-parser";

import { convertToSlug } from "../helpers/slugify";
import { parseContentLinks } from "../helpers/content-links";

class Publication extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    this.setState({
      isVisible: true,
    });
  }

  render() {
    const { data, pageContext, location } = this.props;
    const publicationCodename = pageContext.codename;
    const publicationTitle = pageContext.name;
    const isTest =
      data.contentItem.kenticoElements.test_publication.value.length > 0 &&
      data.contentItem.kenticoElements.test_publication.value[0].codename ===
        "yes";

    let html;
    let H2Array = [];
    if (typeof document !== "undefined") {
      const el = document.createElement("html");
      el.innerHTML = data.contentItem.kenticoElements.landing_page_text.value;
      const all = el.querySelectorAll("body > *");
      if (all.length) {
        html = Array.from(all);
        html.map((element, index) => {
          if (element.tagName.toLowerCase() === "h2") {
            element.id = convertToSlug(element.innerHTML);
            element.classList.add("article__section-header--red");
            H2Array.push(element.innerHTML);
          }

          // LINK PARSING
          parseContentLinks(
            element,
            data.contentItem.fields.linksArray,
            data.allKenticoCloudItemSubchapter.edges.concat(
              data.allKenticoCloudItemChapter.edges
            ),
            location,
            pageContext.language
          );
        });
      }
    }

    return (
      <Layout
        publicationCodename={publicationCodename}
        publicationTitle={publicationTitle}
        showMenu={true}
        showButton={false}
        hasMenu={true}
        language={pageContext.language}
        path={location.pathname}
        canonicalUrl={pageContext.canonicalUrl}
        googleTagId={pageContext.googleTagId}
        isTest={isTest}
        pageContext={pageContext}
      >
        <article className={`article ${this.state.isVisible ? "visible" : ""}`}>
          <div className={`article__header article__header--red`}>
            <div>
              <h1 className="article__title">
                {data.contentItem.kenticoElements.displayed_title.value}
              </h1>
            </div>
          </div>
          <div className="article__inner">
            {html
              ? html.map((element, index) => {
                  if (element.tagName.toLowerCase() === "h2") {
                    return (
                      <div className="article__section-header" key={index}>
                        {parse(element.outerHTML)}
                      </div>
                    );
                  } else {
                    return parse(element.outerHTML);
                  }
                })
              : ""}
          </div>
        </article>
      </Layout>
    );
  }
}

export default Publication;

export const query = graphql`
  query publicationQuery($codename: String!) {
    contentItem(system: { codename: { eq: $codename } }) {
      system {
        name
        codename
      }
      kenticoElements {
        landing_page_text {
          value
        }
        displayed_title {
          value
        }
        url {
          value
        }
        test_publication {
          value {
            codename
          }
        }
      }
      fields {
        linksArray {
          url_key
          codename
          type
          url_slug
        }
      }
    }
    allKenticoCloudItemSubchapter {
      edges {
        node {
          system {
            codename
            type
          }
          elements {
            url {
              value
            }
          }
          usedByContentItems {
            system {
              codename
              name
            }
            elements {
              url {
                name
                value
                type
              }
            }
            usedByContentItems {
              system {
                codename
                name
              }
              elements {
                url {
                  name
                  value
                  type
                }
              }
              usedByContentItems {
                system {
                  codename
                  name
                }
                elements {
                  language {
                    name
                    taxonomyGroup
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
    allKenticoCloudItemChapter {
      edges {
        node {
          system {
            codename
            type
          }
          elements {
            url {
              value
            }
          }
          usedByContentItems {
            system {
              codename
              name
            }
            elements {
              url {
                name
                value
                type
              }
            }
          }
        }
      }
    }
  }
`;

Publication.propTypes = {
  data: PropTypes.object,
};
